import {
    SpinButtonEvents,
    SpinButtonModule,
    SpinButtonView,
    SpinButtonViewEvents,
    SpinButtonViewMobile,
    SpinButtonViewMobileLandscape
} from '@gongxigames/framework/slot/modules/spinbutton';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

// @ts-ignore
// TODO: refactor required
export class SpinButtonBasicState extends ModuleState<SpinButtonView | SpinButtonViewMobile, SpinButtonModule> {

    protected setupEvents(): void {
        this.setEventHandler(SpinButtonViewEvents.SPIN_BUTTON_CLICKED, this.onSpinButtonClicked.bind(this));
        this.setEventHandler(SpinButtonViewMobileLandscape.SPINS_LEFT_BUTTON_CLICKED, this.onSpinsLeftButtonClicked.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinStarted.bind(this));
        this.setEventHandler(GenericPopupEvents.INTRO_STARTED, this.onPopupStarted.bind(this));
        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
    }

    protected onPopupStarted(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.onFreeSpinsIntroStarted();
        }
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.onFreeSpinsOutroFinished();
        }
    }

    public onEnterState(): void {
    }

    public onLeaveState(): void {
    }

    protected onFreeSpinsIntroStarted(): void {
        this.view.uninitAutoplay();
    }

    protected onFreeSpinsOutroFinished(): void {
        this.view.initMainGame();
    }

    protected onSpinButtonClicked(): void {
        this.emit(SpinButtonEvents.SPIN_BUTTON_PRESSED);
    }

    protected onSpinsLeftButtonClicked(): void {
        this.onSpinButtonClicked();
    }

    protected onReelsSpinStarted(): void {
        this.module.disableButton(UIDisableReason.SPIN_RESPONSE);
        this.module.enableButton(UIDisableReason.TRIGGERING_FEATURE);
        this.module.enableHold(UIDisableReason.TRIGGERING_FEATURE);
        this.module.gotoState(SpinButtonModule.REELS_SPINNING_STATE);
    }
}
